import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import swal from 'sweetalert2';
import { connect } from 'react-redux';
import { getSection, getSectionGuardians, setActiveSection, toggleSelectedSection, clearSelectedSections } from 'actions/sections';
import { Expandable, Spinner } from 'UI';
import { Checkbox, Icon, translate } from '@haldor/ui';
import './MultipleSectionSelector.scss';

var MultipleSectionSelector = /*#__PURE__*/function (_Component) {
  _inherits(MultipleSectionSelector, _Component);

  var _super = _createSuper(MultipleSectionSelector);

  function MultipleSectionSelector(props) {
    var _this;

    _classCallCheck(this, MultipleSectionSelector);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.props.setActiveSection();

      _this.props.clearSelectedSections();

      _this.setState({
        sections: []
      });
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      if (prevProps.selectGuardians != _this.props.selectGuardians) {
        _this.onUpdateResult();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.state.sections != null) {
        _this.state.sections.forEach(function (section) {
          if (_this.props.value != null) {
            if (section.id == _this.props.value) {
              section.checked = false;

              _this.onSectionChange(section);
            }
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "promptEmpty", function () {
      var translate = _this.props.translate;

      if (_this.props.type == 'assignment') {
        swal.fire({
          title: _this.props.translate('The group contains no students'),
          showCancelButton: false,
          confirmButtonText: _this.props.translate('Ok'),
          html: "\n\t\t\t\t".concat(translate('The group you selected does not contain any students. You can`t create assignments for a group without students. The group may lack students due to the fact that:'), "\n\t\t\t\t<br />\n\t\t\t\t<ul>\n\t\t\t\t\t<li>").concat(translate('No students have been added to the group. Make sure your team/Microsoft 365 group includes students.'), "</li>\n\t\t\t\t\t<li>").concat(translate('Students have not been activated on the team. To do this, use Microsoft Teams.'), "</li>\n\t\t\t\t\t<li>").concat(translate('The group could not be loaded correctly. Close the form and reload the page, then try again.'), "</li>\n\t\t\t\t</ul>\n\t\t\t\t<br />\n\t\t\t\t")
        });
      }

      if (_this.props.type == 'plan') {
        swal.fire({
          title: _this.props.translate('The group contains no students'),
          showCancelButton: false,
          confirmButtonText: _this.props.translate('Ok'),
          html: "\n\t\t\t\t".concat(translate('create-planning-selected-group-no-students'), "\n\t\t\t\t<br />\n\t\t\t\t<ul>\n\t\t\t\t\t<li>").concat(translate('No students have been added to the group. Make sure your team/Microsoft 365 group includes students.'), "</li>\n\t\t\t\t\t<li>").concat(translate('Students have not been activated on the team. To do this, use Microsoft Teams.'), "</li>\n\t\t\t\t\t<li>").concat(translate('The group could not be loaded correctly. Close the form and reload the page, then try again.'), "</li>\n\t\t\t\t</ul>\n\t\t\t\t<br />\n\t\t\t\t")
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSectionChange", function (section, checked) {
      if (!section.checked) {
        section.checked = true;
      } else {
        section.checked = checked;
      }

      if (section.students == null || section.students.length == 0) {
        _this.loadSectionStudents(section, section.checked);
      }

      if (section.students != null) {
        if (section.checked && section.students.length == 0) {
          if (_this.props.type == 'assignment') {
            section.checked = false;

            _this.setState({});

            return false;
          }
        }

        _this.markSectionStudents(section, checked);
      }

      _this.props.toggleSelectedSection(section);
    });

    _defineProperty(_assertThisInitialized(_this), "onSectionOpenChange", function (section) {
      section.open = !section.open;

      _this.setState({});

      if (section.students == null || section.students.length == 0) {
        _this.loadSectionStudents(section);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "markSectionStudents", function (section, checked) {
      if (_this.props.selectGuardians) {
        section.students.forEach(function (student) {
          student.guardians.forEach(function (guardian) {
            guardian.checked = checked;
            student.checked = section.checked;
          });
        });
      } else {
        section.students.forEach(function (student) {
          student.checked = checked;
        });
      }

      _this.setState({}, function () {
        _this.onUpdateResult();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "loadSectionStudents", function (section) {
      var prompt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var sections = _this.state.sections;
      var stateSection = sections.find(function (t) {
        return t.id == section.id;
      });
      stateSection.loading = true;

      _this.setState({
        sections: sections
      }, function () {
        if (_this.props.selectGuardians) {
          _this.props.getSectionGuardians(section.id).then(function () {
            stateSection.students = JSON.parse(JSON.stringify(_this.props.guardians));
            stateSection.students.forEach(function (student) {
              student.guardians.forEach(function (guardian) {
                guardian.checked = section.checked;
              });
              student.checked = section.checked;
            });
            stateSection.loading = false;

            _this.setState({
              sections: sections
            }, function () {
              _this.onUpdateResult();
            });
          });
        } else {
          _this.props.getSection(section.id).then(function () {
            if (_this.props.activeSection != null) {
              stateSection.students = JSON.parse(JSON.stringify(_this.props.activeSection.students));
              stateSection.courses = JSON.parse(JSON.stringify(_this.props.activeSection.courses));

              if (stateSection.students != null) {
                if (stateSection.students.length == 0 && prompt) {
                  _this.promptEmpty();

                  if (_this.props.type == 'assignment') {
                    stateSection.checked = false;
                  }
                }

                stateSection.students.forEach(function (student) {
                  student.checked = section.checked;
                });
              }

              stateSection.loading = false;

              _this.setState({
                sections: sections
              }, function () {
                _this.onUpdateResult();
              });
            }
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onGuardiansUpdate", function (section) {
      var checkedGuardians = section.students.find(function (student) {
        return student.guardians.find(function (guardian) {
          return guardian.checked == true;
        });
      });

      if (checkedGuardians != null) {
        section.checked = true;
      } else {
        section.checked = false;
      }

      _this.setState({}, function () {
        _this.onUpdateResult();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onStudentsUpdate", function (section) {
      var checkedStudents = section.students.find(function (student) {
        return student.checked == true;
      });

      if (checkedStudents != null) {
        if (!section.checked) {
          _this.props.toggleSelectedSection(section);
        }

        section.checked = true;
      } else {
        // No students are no longer checked
        if (section.checked) {
          _this.props.toggleSelectedSection(section);
        }

        section.checked = false;
      }

      _this.setState({}, function () {
        _this.onUpdateResult();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onStudentChange", function (student, section) {
      student.checked = student.checked ? false : true;

      _this.setState({}, function () {
        _this.onStudentsUpdate(section);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onGuardianChange", function (guardian, section) {
      guardian.checked = guardian.checked ? false : true;

      _this.setState({}, function () {
        _this.onGuardiansUpdate(section);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onUpdateResult", function () {
      var filtered = _this.state.sections.filter(function (t) {
        return t.checked || t.active;
      });

      var sections = [];
      filtered.forEach(function (section) {
        var sectionObject = {
          id: section.id,
          courses: section.courses,
          type: section.type,
          students: section.students != null ? section.students.filter(function (t) {
            return t.checked;
          }) : [],
          graphId: section.graphId,
          title: section.title
        };

        if (_this.props.selectGuardians) {
          sectionObject.guardians = [];
          section.students.forEach(function (student) {
            if (student.guardians != null) {
              student.guardians.forEach(function (guardian) {
                if (guardian.checked) {
                  sectionObject.guardians.push(guardian);
                }
              });
            }
          });
        }

        sections.push(sectionObject);
      });

      _this.props.onChange(sections);
    });

    _defineProperty(_assertThisInitialized(_this), "onSectionOpen", function (section, toggle) {
      if (section.open != null) {
        section.open = !section.open;
      } else {
        section.open = true;
      }

      if (section.students == null || section.students.length == 0) {
        _this.loadSectionStudents(section);
      }

      toggle();
    });

    _defineProperty(_assertThisInitialized(_this), "renderStudent", function (student, section) {
      if (_this.props.selectGuardians) {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            marginTop: '0.75rem'
          },
          key: student.id
        }, student.firstName, " ", student.lastName, /*#__PURE__*/React.createElement("div", {
          style: {
            marginTop: '0.45rem'
          }
        }, student.guardians.map(function (guardian) {
          return /*#__PURE__*/React.createElement(Checkbox, {
            key: student.id + '-' + guardian.id,
            onChange: function onChange() {
              return _this.onGuardianChange(guardian, section);
            },
            value: guardian.checked,
            label: "".concat(guardian.firstName, " ").concat(guardian.lastName != null ? guardian.lastName : '')
          });
        })));
      }

      return /*#__PURE__*/React.createElement("div", {
        key: student.id
      }, /*#__PURE__*/React.createElement(Checkbox, {
        onChange: function onChange() {
          return _this.onStudentChange(student, section);
        },
        value: student.checked,
        label: "".concat(student.firstName, " ").concat(student.lastName)
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderSection", function (section) {
      var title = /*#__PURE__*/React.createElement("div", {
        className: "df aic jcb"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(Checkbox, {
        value: section.checked,
        onChange: function onChange(checked) {
          return _this.onSectionChange(section, checked);
        },
        label: section.title,
        disabled: _this.props.disabled || section.classroomUrl == null || section.classroomUrl == ''
      })), section.students != null && section.students.length == 0 ? /*#__PURE__*/React.createElement("span", {
        style: {
          fontWeight: 400,
          fontSize: '1rem',
          marginRight: '1rem'
        }
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          position: 'relative',
          top: 2,
          marginRight: '.3rem'
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Alert_Red"
      })), _this.props.translate('The group contains no students')) : null, section.classroomUrl == null || section.classroomUrl == '' ? /*#__PURE__*/React.createElement("span", {
        style: {
          fontWeight: 400,
          fontSize: '1rem',
          marginRight: '1rem'
        }
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          position: 'relative',
          top: 2,
          marginRight: '.3rem'
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Alert_Red"
      })), _this.props.translate('Workspace missing')) : null);

      if (section.open == null) {
        section.open = false;
      }

      return /*#__PURE__*/React.createElement(Expandable, {
        open: section.open,
        title: title,
        key: section.id,
        onPlus: function onPlus(toggle) {
          _this.onSectionOpenChange(section);
        },
        onClick: function onClick(toggle) {
          return false;
        }
      }, section.error ? /*#__PURE__*/React.createElement("div", {
        className: "section-error"
      }, section.error) : null, section.loading ? /*#__PURE__*/React.createElement(Spinner, {
        small: true,
        center: true
      }) : null, section.students ? section.students.sort(function (a, b) {
        return a.lastName.localeCompare(b.lastName);
      }).map(function (student) {
        return _this.renderStudent(student, section);
      }) : null);
    });

    var _sections = JSON.parse(JSON.stringify(props.sections));

    if (props.mentorGroups) {
      _sections = JSON.parse(JSON.stringify(props.mentorSections));
    }

    if (_sections != null) {
      _sections = _sections.sort(function (a, b) {
        return a.title > b.title ? 1 : b.title > a.title ? -1 : 0;
      });
      _sections = _sections.filter(function (section) {
        return section.userRole == "OWNER";
      });

      _sections.forEach(function (section) {
        if (_this.props.value != null) {
          if (section.id == _this.props.value) {
            section.checked = true;
            return section;
          }
        }
      });
    }

    _this.state = {
      sections: _sections
    };
    return _this;
  }

  _createClass(MultipleSectionSelector, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var disabled = this.props.disabled;

      if (this.props.sections != null) {
        return /*#__PURE__*/React.createElement("div", {
          className: disabled ? "multi-user-select disabled" : "multi-user-select"
        }, this.state.sections.map(function (section) {
          return _this2.renderSection(section);
        }));
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "user-select"
      });
    }
  }]);

  return MultipleSectionSelector;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    sections: state.sections.educationGroups,
    mentorSections: state.sections.mentorGroups,
    activeSection: state.sections.activeSection,
    guardians: state.sections.guardians
  };
}

export default connect(mapStateToProps, {
  getSection: getSection,
  getSectionGuardians: getSectionGuardians,
  setActiveSection: setActiveSection,
  toggleSelectedSection: toggleSelectedSection,
  clearSelectedSections: clearSelectedSections
})(MultipleSectionSelector);